import { NavSlimVacationCookieData } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  ADULTS_PLURAL_TEXT,
  ADULTS_SINGULAR_TEXT,
  CHILD_PLURAL_TEXT,
  CHILD_SINGULAR_TEXT,
  ROOM_PLURAL_TEXT,
  ROOM_SINGULAR_TEXT
} from '../../constants/header-slim/header-slim.constants';

export function emptyVacationCookieData(): NavSlimVacationCookieData {
  return {
    origin: '',
    destination: '',
    dates: '',
    rooms: '',
    adults: '',
    children: ''
  };
}

export function parseRoute(route: string): {
  origin: string;
  destination: string;
} {
  const separator = ' - ';
  const idx = route.indexOf(separator);
  if (idx === -1) return { origin: '', destination: route };
  return {
    origin: route.substring(0, idx).trim(),
    destination: route.substring(idx + separator.length).trim()
  };
}

export function parsePassengers(passengerStr: string): {
  rooms: string;
  adults: string;
  children: string;
} {
  return {
    rooms: formatLabelFromStr(
      passengerStr,
      /(\d+)\s+Room/i,
      ROOM_SINGULAR_TEXT,
      ROOM_PLURAL_TEXT
    ),
    adults: formatLabelFromStr(
      passengerStr,
      /(\d+)\s+Adult/i,
      ADULTS_SINGULAR_TEXT,
      ADULTS_PLURAL_TEXT
    ),
    children: formatLabelFromStr(
      passengerStr,
      /(\d+)\s+Child/i,
      CHILD_SINGULAR_TEXT,
      CHILD_PLURAL_TEXT
    )
  };
}

export function formatLabel(
  count: number,
  singular: string,
  plural: string
): string {
  if (!count) return '';
  return `${count} ${count === 1 ? singular : plural}`;
}

function formatLabelFromStr(
  str: string,
  pattern: RegExp,
  singular: string,
  plural: string
): string {
  const match = str.match(pattern);
  if (!match) return '';
  return formatLabel(parseInt(match[1], 10), singular, plural);
}
